import { createContext, useContext, useState, useEffect } from "react";

const CustomerAuthContext = createContext(null);
const TOKEN_KEY = "piikk_customer_token";

export function CustomerAuthProvider({ children }) {
  const [customer, setCustomer] = useState(null); // { phone, name, token }

  useEffect(() => {
    try {
      const stored = localStorage.getItem(TOKEN_KEY);
      if (stored) setCustomer(JSON.parse(stored));
    } catch {
      localStorage.removeItem(TOKEN_KEY);
    }
  }, []);

  const setVerified = (phone, name, token) => {
    const data = { phone, name, token };
    localStorage.setItem(TOKEN_KEY, JSON.stringify(data));
    setCustomer(data);
  };

  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    setCustomer(null);
  };

  const customerHeader = () =>
    customer?.token ? { headers: { Authorization: `Bearer ${customer.token}` } } : {};

  const isVerified = (phone) =>
    !!(customer && customer.phone === phone && customer.token);

  return (
    <CustomerAuthContext.Provider value={{ customer, setVerified, logout, customerHeader, isVerified }}>
      {children}
    </CustomerAuthContext.Provider>
  );
}

export const useCustomerAuth = () => useContext(CustomerAuthContext);
